import { render, staticRenderFns } from "./DetailLaporanProgramPemilikSistem.vue?vue&type=template&id=7592a520&"
import script from "./DetailLaporanProgramPemilikSistem.vue?vue&type=script&lang=js&"
export * from "./DetailLaporanProgramPemilikSistem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports